import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=3a59f331"
import script from "./Performance.vue?vue&type=script&lang=ts"
export * from "./Performance.vue?vue&type=script&lang=ts"
import style0 from "./Performance.vue?vue&type=style&index=0&id=3a59f331&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports